import React from "react";
import firebase from "../../firebase";
import { connect } from "react-redux";
import { setCurrentChannel, setPrivateChannel } from "../../actions";
import {withRouter} from "react-router-dom";
import {
    ROUTES_NAMES,
  } from "../../routes";

class ConnectUserOnClick extends React.Component {

    state = {
        friends:[],
        blocked:[],
        otherUsersFriends:[],
        usersRef: firebase.database().ref("users"),
        replacePage: this.props.replacePage && this.props.replacePage===true
      };

      componentDidMount() {
          this.addListeners(this.props.currentUser.uid);
      }
    
      componentWillUnmount() {
        this.removeListeners();
      }
    
      removeListeners = () => {
        this.state.usersRef.child(`${this.props.currentUser.uid}/friends`).off();
      };
    
      addListeners = (currentUserUid) => {
        let loadedFriends = [];
        this.state.usersRef
          .child(`${this.props.currentUser.uid}/friends`)
          .on("child_added", (snap) => {
            if (currentUserUid !== snap.key) {
              let user = snap.val();
              user["status"] = "offline";
              user["uid"] = user.uid;
              user["key"] = snap.key;
              loadedFriends.unshift(user);
              this.setState({ friends: loadedFriends });
            }
          });
    
        loadedFriends = [];
        this.state.usersRef
          .child(`${this.props.currentUser.uid}/friends`)
          .on("child_removed", (snap) => {
            if (currentUserUid !== snap.key) {
              let user = snap.val();
              user["uid"] = user.uid;
              loadedFriends = this.state.friends.filter((f) => f.uid !== user.uid);
              this.setState({ friends: loadedFriends });
            }
          });

          let loadedList = [];
        this.state.usersRef
          .child(`${this.props.user.id}/friends`)
          .on("child_added", (snap) => {
              let user = snap.val();
              user["status"] = "offline";
              user["uid"] = user.uid;
              user["key"] = snap.key;
              loadedList.unshift(user);
              this.setState({ otherUsersFriends: loadedList });
          });
    
        loadedList = [];
        this.state.usersRef
          .child(`${this.props.user.id}/friends`)
          .on("child_removed", (snap) => {
              let user = snap.val();
              user["uid"] = user.uid;
              loadedList = this.state.friends.filter((f) => f.uid !== user.uid);
              this.setState({ otherUsersFriends: loadedList });
          });

          let blocked = [];
          this.state.usersRef
            .child(`${this.props.user.id}/blocked`)
            .on("child_added", (snap) => {
              if (currentUserUid !== snap.key) {
                let user = snap.val();
                user["uid"] = user.uid;
                user["added"] = false;
                user["key"] = snap.key;
                blocked.push(user);
                this.setState({ blocked: blocked });
              }
            });
      
          blocked = [];
          this.state.usersRef
            .child(`${this.props.user.id}/blocked`)
            .on("child_removed", (snap) => {
              if (currentUserUid !== snap.key) {
                let user = snap.val();
                // console.log(user)
                user["uid"] = user.uid;
                blocked = this.state.blocked.filter((f) => f.uid !== user.uid);
                this.setState({ blocked: blocked });
              }
            });
    
        }

        addFriend(user) {
          console.log("User to add")
          let idToAdd = user.userId ? user.userId : user.id
          console.log(idToAdd)
            const userToAdd = {
                name:user.name,
                avatar:user.avatar,
                status:"offline",
                uid:idToAdd,
                unread:false,
            }
            
            this.state.usersRef
              .child(`${this.props.currentUser.uid}/friends`)
              .push()
              .update(userToAdd)
              .then(() => {
                console.log("Friend added");
                this.closeModal();
              })
              .catch((err) => console.error(err));
          }

        isFriend(user) {
            return this.state.friends.some((f) => {
              return f.uid === user.id;
            });
          }
        isCurrentUserBlocked() {
            return this.state.blocked.some((f) => {
              return f.uid === this.props.currentUser.uid
            })
        }

        isCurrentUserFriend() {
            return this.state.otherUsersFriends.some((f) => {
              return f.uid === this.props.currentUser.uid;
            });
        }

        addCurrentUserAsFriend() {
          let user = this.props.currentUser
          
            const userToAdd = {
              name:user.displayName,
              avatar:user.photoURL,
              status:"offline",
              uid:user.uid,
              unread:false,
          }

          this.state.usersRef
            .child(`${this.props.user.id}/friends`)
            .push()
            .update(userToAdd)
            .then(() => {
              console.log("Friend added");
            })
            .catch((err) => console.error(err));

        }

        changeChannel = (user) => {
            const channelId = this.getChannelId(user.id);
            const channelData = {
              id: channelId,
              name: user.name,
            };
            this.props.setCurrentChannel(channelData);
            this.props.setPrivateChannel(true);
          };
        
        getChannelId = (userId) => {
            const currentUserId = this.props.currentUser.uid;
            return userId < currentUserId
              ? `${userId}/${currentUserId}`
              : `${currentUserId}/${userId}`;
        };

        navigateToChat(){
            this.props.replacePage ? this.props.history.replace(ROUTES_NAMES.chat) : this.props.history.push(ROUTES_NAMES.chat);
        }
  
        onClickUser(user){
          console.log("1")
            if(!this.isFriend(user))
                {this.addFriend(user)}
            this.changeChannel(user);

            console.log("2")
            if( (!this.isCurrentUserBlocked()) && (!this.isCurrentUserFriend()))
              {this.addCurrentUserAsFriend()}

              console.log("3")
            this.navigateToChat();
        }

        

        render() {
            return (
            <string onClick={() => this.onClickUser(this.props.user)}>{this.props.user.name}</string>
                );
  }
}

const mapStateToProps = (state) => ({
    currentUser: state.user.currentUser,
  });

export default withRouter(connect(mapStateToProps, { setCurrentChannel, setPrivateChannel })(
  ConnectUserOnClick
));



// WEBPACK FOOTER //
// ./src/components/MetaPanel/ConnectUserOnClick.js